export const getSheetResourceUpdates = (sheet, workers = [], equipment = []) => {
  const sheetWorkers = JSON.parse(JSON.stringify(sheet.workers));
  workers.forEach(upWorker => {
    const sheetWorkerIndex = sheetWorkers.findIndex(w => w?._id === upWorker._id);
    if (!~sheetWorkerIndex) {
      sheetWorkers.push(upWorker);
      return;
    }
    if (upWorker.deleted) sheetWorkers[sheetWorkerIndex] = null;
    else sheetWorkers[sheetWorkerIndex] = upWorker;
  })

  const sheetEquipment = JSON.parse(JSON.stringify(sheet.equipment));
  equipment.forEach(upEquip => {
    const sheetEquipIndex = sheetEquipment.findIndex(w => w?._id === upEquip._id);
    if (!~sheetEquipIndex) {
      sheetEquipment.push(upEquip);
      return;
    }
    if (upEquip.deleted) sheetEquipment[sheetEquipIndex] = null;
    else sheetEquipment[sheetEquipIndex] = upEquip;
  });

  return { workers: sheetWorkers.filter(worker => !!worker && !worker?.deleted), equipment: sheetEquipment.filter(equip => !!equip && !equip?.deleted) }
}

export const getSheetResourceDictionaries = (sheets, workers = [], equipment = []) => {
  const updatedWorkers = workers?.filter(workerData => sheets.some(sheet => sheet._id === workerData.sheetId));
  const updatedEquipment = equipment?.filter(equipData => sheets.some(sheet => sheet._id === equipData.sheetId));
  if (!updatedWorkers?.length && !updatedEquipment?.length) return { updatedWorkersBySheet: {}, updatedEquipmentBySheet: {} };

  const updatedWorkersBySheet = updatedWorkers.reduce((dic, workerData) => {
    if (!dic[workerData.sheetId]) dic[workerData.sheetId] = { workers: [] };
    dic[workerData.sheetId].workers.push(workerData);
    return dic;
  }, {})
  const updatedEquipmentBySheet = updatedEquipment.reduce((dic, equipData) => {
    if (!dic[equipData.sheetId]) dic[equipData.sheetId] = { equipment: [] };
    dic[equipData.sheetId].equipment.push(equipData);
    return dic;
  }, {})
  return { updatedWorkersBySheet, updatedEquipmentBySheet };
}